import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useAI } from "@/context/AIContext";
import { Button } from "@/components/ui/button";
import { Cpu, LogOut, Sparkles } from "lucide-react";

export const Logo = ({ className = "" }) => (
  <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="nav-logo">
    <span className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-[#EEF1F3] border border-[#1C2A38]/10">
      <Cpu className="h-4 w-4 text-[var(--teal)]" strokeWidth={2.2} />
    </span>
    <span className="font-wordmark text-xl font-700 tracking-tight text-[#1C2A38]">ROSA</span>
  </Link>
);

export default function Navbar() {
  const { user, logout } = useAuth();
  const { openAI } = useAI();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass border-b border-[#1C2A38]/10">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
        <div className="flex items-center gap-10">
          <Logo />
          <div className="hidden items-center gap-1 md:flex">
            <button
              onClick={() => openAI()}
              data-testid="nav-link-ai-sourcing"
              className="flex items-center gap-1.5 rounded-md px-3 py-2 text-sm text-[#475569] transition-colors hover:text-[#1C2A38] hover:bg-[#1C2A38]/5"
            >
              <Sparkles className="h-4 w-4 text-[var(--teal-deep)]" /> AI Sourcing
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard">
                <Button variant="ghost" className="text-[#1C2A38] hover:bg-[#1C2A38]/5">
                  Dashboard
                </Button>
              </Link>
              <Button
                onClick={async () => { await logout(); navigate("/"); }}
                data-testid="nav-logout"
                variant="outline"
                className="border-[#1C2A38]/15 bg-transparent text-[#1C2A38] hover:bg-[#1C2A38]/5"
              >
                <LogOut className="mr-1.5 h-4 w-4" /> Sign out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login">
                <Button variant="ghost" className="text-[#1C2A38] hover:bg-[#1C2A38]/5">
                  Sign in
                </Button>
              </Link>
              <Link to="/register" data-testid="nav-register">
                <Button className="bg-[var(--teal)] font-600 text-[#063b34] hover:bg-[#1ee9cf]">
                  Get started
                </Button>
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
